module.exports = __webpack_public_path__ + "img/40_38_030_640.1196bcfd.jpg";